import React from 'react'

import styles from './Contact.module.css'

import { Grid } from '@material-ui/core'

import Map from '../Map/Map'

const Contact = () => {
  return (
    <Grid
      container
      className="bgWhite extraPaddingBottom"
      justify="center"
      alignItems="center"
    >
      <Grid item xs={12} md={5} lg={4}>
        <form
          method="post"
          action="https://formspree.io/mwkrwzne"
          className={styles.form}
        >
          <input
            type="text"
            name="name"
            id="name"
            placeholder="name"
            required
          />

          <input
            type="email"
            name="email"
            id="email"
            placeholder="email"
            required
          />

          <input
            type="text"
            name="subject"
            id="subject"
            placeholder="subject"
            required
          />

          <textarea
            name="message"
            id="message"
            rows="6"
            placeholder="message"
            required
          />

          <button type="submit">Send</button>
        </form>
      </Grid>
      <Grid item xs={12} md={5} lg={4} className={styles.gmap}>
        <Map />
      </Grid>
    </Grid>
  )
}

export default Contact
